import { createSelector } from '@reduxjs/toolkit';
import { useAppSelector } from 'store/hooks';
import { WashhubState } from './washhub.slice';

const washhubRootStateSelector = (state: any) => state.washhub as WashhubState;

export const washhubSelector = createSelector(
  washhubRootStateSelector,
  ({ locations }) => locations,
);

export const locationSelector = createSelector(
  washhubRootStateSelector,
  ({ selectedLocation }) => selectedLocation,
);

export const selectors = {
  useAllWashHubs: () => useAppSelector(washhubSelector),
  useSelectedWashHub: () => useAppSelector(locationSelector),
  useSelectedWashHubId: () => useAppSelector(locationSelector)?._id || '',
  useIsWashHubIdValid: () => {
    const washHubId = useAppSelector(locationSelector)?._id;
    return (
      washHubId !== null &&
      washHubId !== undefined &&
      (washHubId === '' || Boolean(washHubId))
    );
  },
};
